export const generateSchema = (data) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: data.accordions.map((panel) => ({
      '@type': 'Question',
      name: panel.heading,
      acceptedAnswer: {
        '@type': 'Answer',
        text: panel.body,
      },
    })),
  };

  return schema;
};
